import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { Typography } from '@mui/material';

export default function OverlayLoader({open,text}) {
  

  return (
    <>
      
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1, display: 'flex', flexDirection: 'column' }}
        open={open}
      >
        <CircularProgress color="inherit" />
        <Typography >
        {text ?  text:'Loading..' }
        </Typography >
      </Backdrop>
    </>
  );
}